<template src="./template.html"></template>

<script>
import { isArray, isEmpty, isObject } from 'lodash'

export default {
  name: 'ProfileTopRightSection',
  props: {
    invoiceAddress: Object,
    deliveryAddress: Object,
    userCustomFields: Object,
    religions: Object,
  },
  computed: {
    userSelectedCommaSeparatedReligions() {
      const religionOptions = this.religions && this.religions.options
      return religionOptions &&
        religionOptions.filter(religion => religion.user_selected).map(religion => religion.name).join(', ') || ''
    },
    customFieldTitle() {
      return this.isInCustomerProfileOptions('Cards', 'custom-fields') ?
        (this.userCustomFields && this.userCustomFields.title) : this.$t('profile.own_profile.personal_data.title')
    },
  },
  methods: {
    displayValue(rawValue) {
      const value = isArray(rawValue) ? rawValue[0] : rawValue
      return value ? (
        isObject(value) ? (
          isEmpty(value) ? '' : value.text
        ) : value
      ) : ''
    },
  },
}
</script>
